module.exports = __webpack_public_path__ + "static/STG20_Desktop_2880_Module5_Drink4_Rita-223cd704c63b4d71b771b8ddf9a362d1.png";